/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react';
import { Box, Stack } from '@mui/material';
import CustomBox from 'components/cmn/CustomBox';
import OneButtonDialog from 'components/cmn/OneButtonDialog';
import { useAppDispatch } from 'store';
import { closeDialog } from 'store/dialog/dialogSlice';

interface IAlertMessageDialogProps {
  response: any;
}
function AlertMessageDialog({ response }: IAlertMessageDialogProps): JSX.Element {
  const dispatchApp = useAppDispatch();
  const handleClose = async () => {
    dispatchApp(closeDialog());
  };
  return (
    <OneButtonDialog
      confirmTitle="확인"
      handleConfirm={handleClose}
      content={
        <CustomBox
          title={
            <Stack direction="column" justifyContent="center" alignItems="center">
              <Box>{`${response?.data?.message || '-'}`}</Box>
            </Stack>
          }
          typography="s15w400"
          color="mind.black.A0"
        />
      }
    />
  );
}

export default memo(AlertMessageDialog);
